var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageLyout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 88,
    viewBox: "0 0 114 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11221_16588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 114,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 88,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11221_16588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.793 9.61121H81.958C87.4208 9.61121 91.8574 14.0478 91.8574 19.5106V91.1522C91.8573 96.6149 87.4207 101.052 81.958 101.052H29.6914C25.9084 101.052 22.6253 98.9358 20.9746 95.8212L20.8203 95.5165L20.8174 95.5116L20.6973 95.2626C20.1138 94.0076 19.792 92.6126 19.792 91.1522V35.3993C19.792 34.7735 19.8471 34.1536 19.9736 33.5575L19.9775 33.5399C20.0862 32.9224 20.2675 32.3061 20.5205 31.7284L20.5254 31.7177L20.5293 31.7069C21.0397 30.3753 21.8621 29.1675 22.9443 28.1581L40.1426 12.1932C41.0056 11.394 42.0243 10.7614 43.1113 10.3339L43.5811 10.163L43.5986 10.1571C44.1722 9.94211 44.7873 9.79528 45.4111 9.703C45.879 9.64689 46.3386 9.61121 46.793 9.61121Z",
    fill: "white",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.363 19.5147V91.156C92.363 96.8949 87.7026 101.556 81.9637 101.556H29.6965C26.6342 101.556 23.8997 100.246 21.9932 98.1468C23.2062 98.6475 24.5547 98.9363 25.9605 98.9363H78.2272C83.9661 98.9363 88.627 94.2758 88.627 88.5369V16.8956C88.627 14.1994 87.6062 11.7536 85.9305 9.90479C89.7051 11.4647 92.363 15.1816 92.363 19.5147Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5232 14.8868H51.9698C51.1723 14.8868 50.5254 14.2398 50.5254 13.4424C50.5254 12.645 51.1723 11.998 51.9698 11.998H53.5232C54.3206 11.998 54.9676 12.645 54.9676 13.4424C54.9676 14.2398 54.3206 14.8868 53.5232 14.8868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6446 14.8867H59.1983C58.4009 14.8867 57.7539 14.2397 57.7539 13.4423C57.7539 12.6449 58.4009 11.9979 59.1983 11.9979H69.6446C70.442 11.9979 71.0889 12.6449 71.0889 13.4423C71.0889 14.2397 70.442 14.8867 69.6446 14.8867Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.4207 9.68628V26.3318C43.4207 29.2002 41.0954 31.5255 38.2271 31.5255H20.0605C20.5997 30.1196 21.4664 28.8483 22.6025 27.7892L39.8003 11.8242C40.8402 10.8612 42.092 10.1292 43.4207 9.68628Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9743 65.3459C23.5721 65.3459 24.057 64.861 24.057 64.2632V47.1075C24.057 46.5097 23.5721 46.0248 22.9743 46.0248C22.3766 46.0248 21.8916 46.5097 21.8916 47.1075V64.2632C21.8916 64.861 22.3766 65.3459 22.9743 65.3459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9743 43.6747C23.5721 43.6747 24.057 43.1897 24.057 42.592V41.4289C24.057 40.8312 23.5721 40.3462 22.9743 40.3462C22.3766 40.3462 21.8916 40.8312 21.8916 41.4289V42.592C21.8916 43.1897 22.3766 43.6747 22.9743 43.6747Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.7013 68.196C81.7013 69.0626 81.0083 69.756 80.1418 69.756H54.3161C53.4689 69.756 52.7754 69.0626 52.7754 68.196C52.7754 67.3294 53.4689 66.6361 54.3161 66.6361H80.1418C81.0083 66.6361 81.7013 67.3294 81.7013 68.196Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4503 45.1631C82.4503 46.0297 81.7568 46.723 80.8903 46.723H73.6684C72.8019 46.723 72.1084 46.0297 72.1084 45.1631C72.1084 44.2964 72.8019 43.6031 73.6684 43.6031H80.8903C81.7568 43.6031 82.4503 44.2964 82.4503 45.1631Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4474 60.5116C82.4474 61.3782 81.7539 62.0716 80.8874 62.0716H30.7387C29.8722 62.0716 29.1787 61.3782 29.1787 60.5116C29.1787 59.6643 29.8722 58.9517 30.7387 58.9517H80.8874C81.7539 58.9517 82.4474 59.6643 82.4474 60.5116Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6961 75.8796C81.6961 76.727 81.003 77.4396 80.1365 77.4396H30.7387C29.8722 77.4396 29.1787 76.727 29.1787 75.8796C29.1787 75.013 29.8722 74.3197 30.7387 74.3197H80.1365C81.003 74.3197 81.6961 75.013 81.6961 75.8796Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1787 68.1955C29.1787 67.3289 29.8722 66.6356 30.7387 66.6356H44.7924C45.6396 66.6356 46.3331 67.3289 46.3331 68.1955C46.3331 69.0621 45.6396 69.7555 44.7924 69.7555H30.7387C29.8722 69.7555 29.1787 69.0621 29.1787 68.1955Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1787 83.5449C29.1787 82.6975 29.8722 81.985 30.7387 81.985H63.4007C64.2677 81.985 64.9607 82.6975 64.9607 83.5449C64.9607 84.4116 64.2677 85.1048 63.4007 85.1048H30.7387C29.8722 85.1048 29.1787 84.4116 29.1787 83.5449Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1787 52.8467C29.1787 51.98 29.8722 51.2867 30.7387 51.2867H40.6951C41.5428 51.2867 42.2552 51.98 42.2552 52.8467C42.2552 53.7133 41.5428 54.4066 40.6951 54.4066H30.7387C29.8722 54.4066 29.1787 53.7133 29.1787 52.8467Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7088 83.545C81.7088 84.4117 81.0158 85.105 80.1493 85.105H71.3481C70.4816 85.105 69.7881 84.4117 69.7881 83.545C69.7881 82.6977 70.4816 81.9851 71.3481 81.9851H80.1493C81.0158 81.9851 81.7088 82.6977 81.7088 83.545Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.456 52.8469C82.456 53.7136 81.7624 54.4068 80.8959 54.4068H48.9468C48.099 54.4068 47.3867 53.7136 47.3867 52.8469C47.3867 51.9803 48.099 51.287 48.9468 51.287H80.8959C81.7624 51.287 82.456 51.9803 82.456 52.8469Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1787 37.498C29.1787 36.6314 29.8722 35.9381 30.7387 35.9381H80.8874C81.7539 35.9381 82.4474 36.6314 82.4474 37.498C82.4474 38.3454 81.7539 39.058 80.8874 39.058H30.7387C29.8722 39.058 29.1787 38.3454 29.1787 37.498Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1787 45.1626C29.1787 44.2959 29.8722 43.6027 30.7387 43.6027H60.5891C61.4561 43.6027 62.1491 44.2959 62.1491 45.1626C62.1491 46.0292 61.4561 46.7225 60.5891 46.7225H30.7387C29.8722 46.7225 29.1787 46.0292 29.1787 45.1626Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9954 85.9502C80.9973 85.9502 85.8628 81.0847 85.8628 75.0827C85.8628 69.0808 80.9973 64.2152 74.9954 64.2152C68.9934 64.2152 64.1279 69.0808 64.1279 75.0827C64.1279 81.0847 68.9934 85.9502 74.9954 85.9502Z",
    fill: "#DCDCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8581 75.0864C85.8581 81.0758 80.9857 85.9481 74.9961 85.9481C70.9136 85.9481 67.3507 83.6949 65.502 80.3824C67.4663 82.5972 70.3551 83.9837 73.5711 83.9837C79.5606 83.9837 84.433 79.1114 84.433 73.1221C84.433 71.1963 83.9322 69.3667 83.0464 67.8068C84.7988 69.7326 85.8581 72.2747 85.8581 75.0864Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1181 80.3159C72.6558 80.3159 72.2138 80.1323 71.8875 79.8059L68.6574 76.5758C67.9775 75.8959 67.9775 74.7945 68.6574 74.1145C69.3373 73.4346 70.4387 73.4346 71.1187 74.1145L73.1181 76.114L78.8713 70.3599C79.5513 69.68 80.6527 69.68 81.3326 70.3599C82.0125 71.0398 82.0125 72.1413 81.3326 72.8212L74.3488 79.8059C74.0224 80.1323 73.5805 80.3159 73.1181 80.3159Z",
    fill: "#8AB497"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLyout);
export default __webpack_public_path__ + "static/media/pageLyout.bd051217cd68fc0b983012221e32c4d6.svg";
export { ForwardRef as ReactComponent };